export default __webpack_public_path__ + "static/media/Dyalog.c0f3bc62.svg";